module.exports = __webpack_public_path__ + "static/media/Guanacaste.d047af95.jpg";